import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2, ShieldCheck } from "lucide-react";
import { authLogin } from "@/lib/api";
import { useAuth } from "@/hooks/useAuth";

export const LoginDialog = ({ open, onOpenChange }) => {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { token, user } = await authLogin(email, pwd);
      login(token, user);
      toast.success(`Bienvenue, ${user.name || user.email}`);
      onOpenChange(false);
      setEmail("");
      setPwd("");
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Connexion impossible");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="login-dialog">
        <DialogHeader>
          <div className="flex items-center gap-2">
            <ShieldCheck className="h-6 w-6 text-[#D4AF37]" />
            <DialogTitle className="font-serif-title text-xl">Espace administrateur</DialogTitle>
          </div>
          <DialogDescription>Connectez-vous pour piloter le registre, les sites et les utilisateurs.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4 pt-2">
          <div className="space-y-1.5">
            <Label className="text-xs uppercase tracking-wide text-slate-600">Email</Label>
            <Input
              type="email"
              className="min-h-[46px] bg-slate-50"
              placeholder="admin@ssg-securite.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email"
              required
            />
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs uppercase tracking-wide text-slate-600">Mot de passe</Label>
            <Input
              type="password"
              className="min-h-[46px] bg-slate-50"
              placeholder="••••••••"
              value={pwd}
              onChange={(e) => setPwd(e.target.value)}
              data-testid="login-password"
              required
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            className="w-full min-h-[48px] bg-[#0A192F] hover:bg-[#1E293B] text-white font-bold border-b-2 border-[#D4AF37]"
            data-testid="login-submit"
          >
            {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Se connecter"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
